import React from 'react';
import { ILabelValuePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { CommanderOfflinePanelProps } from './CommanderOfflinePanel';
import { CBoxOfflineIcon } from '../../../../../../../../assets/dashboard';
import { useTranslation } from 'react-i18next';
import { CommanderAPI } from '../../../../../../../../service/device/CommanderAPI/CommanderAPI';
import { DefaultRightContainer } from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';

function CommanderOfflineUserPanel(props: CommanderOfflinePanelProps) {
  const { panel, layout } = props;
  const {
    isFetching,
    currentData,
    error: errorDevicesConnectionStatus,
  } = CommanderAPI.useGetDevicesConnectionStatusCountByUserQuery();
  const { t } = useTranslation();

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `user`,
    title: panel.title,
    icon: <CBoxOfflineIcon height={'100%'} />,
    content: (
      <DefaultRightContainer>
        {currentData?.mqttDisconnected}
      </DefaultRightContainer>
    ),
    loading: isFetching,
    error: errorDevicesConnectionStatus
      ? t('dashboard.error.fetching')
      : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default CommanderOfflineUserPanel;
